export default "__VITE_ASSET__e3f1364c__"